module.exports = __webpack_public_path__ + "img/1403.686f8efa.svg";